import React, {useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import styles from './SelectMultiple.scss';

import arrow from "./img/arrow-down.png";
import checkGray from './img/icon-check-gray.svg';
import checkGreen from './img/icon-check-green.svg';

const SelectMultiple = (props) => {

	const {
		popupVisible,
		showPopup,
		closePopup,
		onChange,
		question,
		options,
		allDisabled,
		id,
		values,
		labels
	} = props;


	const ref = useRef(null);

	const handleClickOutside = (event) => {
		if (ref.current && !ref.current.contains(event.target)) {
			closePopup();
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);

	const Options = () => {
		return (
			<div className={styles.options} ref={ref}>
				<Question showCloseBtn={1}/>
				<div className={styles.optionsInner}>
					{
						options.length > 0 && options.map(option =>
							<div
								key={'multiple_select_key_' + option.value}
								onClick={() => {
									if (allDisabled.includes(id) && !option.value.includes('all_')) {
										//
									} else {
										onChange(id, option);
									}
								}}>
								<input
									type={'checkbox'}
									checked={values.includes(option.value)}
									disabled={allDisabled.includes(id) && !option.value.includes('all_')}
									onChange={() => {
									}}/>

								{option.label}
							</div>
						)
					}
				</div>
			</div>
		)
	}

	const Question = (props) => {
		return (
			<div className={styles.questionContainer}>
				<div className={styles.checkContainer}>
					<img src={values.length > 0 ? checkGreen : checkGray}/>
				</div>
				<div onClick={togglePopup} className={styles.question}>
					{question}
				</div>
				<div onClick={togglePopup} className={styles.arrow}>
					<img src={arrow}/>
				</div>
				{
					props.showCloseBtn ?
						<div onClick={togglePopup} className={styles.closeBtn}>
							<div className={styles.closeBtnImg}></div>
						</div> : ''
				}
			</div>

		)
	}

	const SelectedOptions = () => {
		if (labels.length > 0) {
			return <div className={styles.selectedOptions}>
				{
					labels.map((label, key) => <span key={'selected_label_' + key}>{label}</span>)
				}
			</div>
		}
		return null
	}

	const togglePopup = () => {
		if (popupVisible) {
			closePopup();
			return;
		}
		showPopup();
	}

	const containerClasses = [];
	containerClasses.push(styles.container);
	if (popupVisible) {
		containerClasses.push(styles.active);
	}


	return (
		<div className={containerClasses.join(' ')}>
			<Question/>
			{popupVisible ? <Options/> : null}
			{!popupVisible ? <SelectedOptions/> : null}
		</div>
	)
}

SelectMultiple.defaultProps = {
	popupVisible: false,
	values: [],
	labels: [],
	allDisabled: []
}

SelectMultiple.propTypes = {
	popupVisible: PropTypes.bool,
	showPopup: PropTypes.func.isRequired,
	closePopup: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	question: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(PropTypes.shape({
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		label: PropTypes.string
	})),
	allDisabled: PropTypes.array,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	values: PropTypes.arrayOf(PropTypes.string),
	label: PropTypes.arrayOf(PropTypes.string)
}

export default SelectMultiple;
